<template>
  <card>
    <!-- Card header -->
    <h3 slot="header" class="mb-0">New Project Milestone for ({{ model.project_name }})</h3>
    <div class="text-right">
    </div>
    <form class="needs-validation"
          @submit.prevent="submit">

      <div class="form-row">
        <b-col md="6">
          <base-input label="Project Milestone *"
                      name="Project Milestone"
                      required
                      placeholder="Project Milestone"
                      v-model="model.milestone_code" @change="updateMilestoneInfo()">
          </base-input>
        </b-col>

        <b-col md="6">
          <base-input label="Project *"
                      name="Project"
                      v-model="model.project_name" disabled>
          </base-input>
        </b-col>
      </div>

      <div class="form-row">
        <b-col md="9">
          <base-input label="Project Milestone Info *"
                      name="Project Milestone Info"
                      required
                      placeholder="Project Milestone Info"
                      v-model="model.milestone_info">
          </base-input>
        </b-col>
        <b-col md="3">
          <base-input label="Project Milestone Sequence (Min = 1) *"
                      name="Project Milestone Sequence"
                      required
                      placeholder="Project Milestone Sequence"
                      v-model="model.milestone_sequence" type="number" min="1">
          </base-input>
        </b-col>
        <!-- <b-col md="3">
          <base-input label="Milestone Initial Progress"
                      name="Milestone Initial Progress"
                      placeholder="Milestone Initial Progress"
                      v-model="model.milestone_progress">
          </base-input>
        </b-col> -->
      </div>

      <base-button type="primary" @click="createData()">Create / Save</base-button>
      <base-button type="primary" @click="$router.back()">Cancel</base-button>
      <div>
        <br>
        <h5 class="text-danger"> Note : <br><br>
                <i>
                1. By Default sequence is set to "1" you can set to any number you want except 0.
                </i>
                <br>
                <i>
                2. All Column are Mandatory for Project Milestone.
                </i>
        </h5>
      </div>
    </form>
  </card>
</template>
<script>
  import BaseSlider from '@/components/BaseSlider'
  import {LoginURL, clientId, clientSecret, apiDomain, getHeader, getcurrentDate} from '@/assets/js/config.js'
  import axios from 'axios'
  import ErrorFunctionMixin from '@/assets/js/errorFunctionMix.js'

  export default {
    mixins: [ErrorFunctionMixin],
    components: {
      BaseSlider
    },
    created()
    {
      var currentDate = getcurrentDate()
      this.model.project_id = this.$route.params.id

      axios.get(apiDomain + 'project/project/' + this.model.project_id, { headers: getHeader() })
      .then ( response => {
        if (response.status === 200)
        {
          this.model.project_name = response.data.data[0].project_name
        }
      })
      .catch ( error => {
        console.log(error.response.status)
        this.errorFunction(error, "Project Information")
      } );

    },
    data() {
      return {
        model: {
          project_id: null,
          project_name: null,
          milestone_code: null,
          milestone_info: null,
          milestone_sequence: 1,
          milestone_progress: 0,
          active_status: 1,
        },
      }
    },
    methods: {
      updateMilestoneInfo()
      {
        this.model.milestone_info = this.model.milestone_code
      },
      createData(){
        if ( !this.model.milestone_code || !this.model.milestone_info || !this.model.project_id || !this.model.milestone_sequence || this.model.milestone_sequence < 1 )
        {
          if ( !this.model.milestone_code )
          {
            this.redErrorNotify( '<b>Invalid Input : Project Milestone is a Mandatory in Project Milestone </b>')
          }
          else if (!this.model.milestone_info)
          {
            this.redErrorNotify( '<b>Invalid Input : Milestone Information is a Mandatory in Project Milestone. </b>' )
          }
          else if ( !this.model.milestone_sequence || this.model.milestone_sequence < 1 )
          {
            this.redErrorNotify( '<b>Invalid Input : Milestone Sequence (Min = 1) is a Mandatory in Project Milestone . </b>' )
          }
          else
          {
            this.redErrorNotify( '<b>Invalid Input : Please fill in all the Mandatory Column in Project Milestone </b>' )
          }
        }
        else
        {
          axios.post(apiDomain + 'project/project_milestone', this.model, { headers: getHeader() })
          .then ( response => {
            if (response.status === 200)
            {
                this.$notify({
                message:
                  '<b>New Project Milestone : ' + this.model.milestone_code + '</b> - Successfully Created.',
                timeout: 10000,
                icon: 'ni ni-bell-55',
                type: 'default',
                });
                this.$router.back()
            }
          })
          .catch ( error => {
              console.log(error.response.data.errors)
              this.errorFunction(error, "Project Milestone")
          });
        }
      },
    }
  }
</script>
<style>
</style>
